import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { Element } from "react-scroll";
import Spinner from "../../UI/Spinner/Spinner";
import FeedBack from "../../UI/FeedBack/FeedBack";
import classes from "./Contact.module.css";

const ContactMe = () => {
  const [error, seterror] = useState(false);
  const [loading, setloading] = useState(false);
  const [success, setsuccess] = useState(false);
  const form = useRef();
  const sendEmail = (e) => {
    e.preventDefault();
    seterror(false);
    setloading(true);
    emailjs
      .sendForm(
        "service_no3wijp",
        "template_2aay04r",
        form.current,
        "b3rHHRt8W47B9_pGK"
      )
      .then(
        (result) => {
          seterror(false);
          setloading(false);
          setsuccess(true);
        },
        (error) => {
          seterror(true);
          setloading(false);
        }
      );
  };
  const removeError = () => {
    seterror(false);
  };
  const showSuccess = (
    <div className={classes.FeedBack}>
      Thank you for your message. I will reply in a jiffy!
    </div>
  );
  return (
    <Element name="Contacts">
      <div className={classes.Contacts}>
        <FeedBack error={error} close={removeError} />

        {success ? (
          showSuccess
        ) : (
          <>
            <p className={classes.ContactWriteUp}>
              I am open to any web app programming; frontend, backend or
              fullstack. Also available for Freelance, contract and open source
              project
            </p>
            <form
              className={classes.Form}
              ref={form}
              onSubmit={sendEmail}
              autoComplete="on"
            >
              <h4 className={classes.Info}>Your Name</h4>
              <input
                type="text"
                name="sender_name"
                autoComplete="sender_name"
                required
              />

              <h4 className={classes.Info}>Your Email</h4>
              <input
                type="email"
                name="sender_email"
                autoComplete="sender_email"
                required
              />

              <h4 className={classes.Info}>Subject</h4>
              <input
                type="text"
                name="message_subject"
                autoComplete="message_subject"
                required
              />
              <br />

              <h4 className={classes.Info}>Message</h4>
              <br />
              <textarea
                name="message"
                className={classes.TextArea}
                autoComplete="message"
                required
              ></textarea>
              <br />
              <button
                className={loading ? classes.Loading : classes.submitMessage}
                disabled={loading}
              >
                {loading ? <Spinner /> : "Submit"}
              </button>
            </form>
          </>
        )}
      </div>
    </Element>
  );
};

export default ContactMe;
